import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileUpload } from "./FileUpload";

const SelectField = ({ f, id, value, onChange }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger data-testid={id} className="rounded-none"><SelectValue placeholder="Choisir…" /></SelectTrigger>
    <SelectContent>{f.options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
  </Select>
);

const TextField = ({ f, id, value, onChange }) => (
  <Input data-testid={id} type={f.type || "text"} value={value ?? ""} placeholder={f.placeholder} onChange={(e) => onChange(f.type === "number" ? Number(e.target.value) : e.target.value)} className="rounded-none" />
);

const INPUTS = {
  textarea: ({ f, id, value, onChange }) => <Textarea data-testid={id} rows={f.rows || 4} value={value || ""} onChange={(e) => onChange(e.target.value)} className="rounded-none" />,
  select: SelectField,
  file: ({ f, id, value, onChange }) => <FileUpload value={value} onChange={onChange} accept={f.accept} label={f.placeholder} testId={id} />,
  text: TextField,
  number: TextField,
};

export const FormField = ({ f, value, onChange, testId }) => {
  const id = `${testId}-${f.name}`;
  if (f.type === "switch") {
    return <label className="flex items-center gap-3 text-sm font-medium"><Switch data-testid={id} checked={!!value} onCheckedChange={onChange} /> {f.label}</label>;
  }
  const Input = INPUTS[f.type || "text"];
  return (
    <div className={`space-y-1.5 ${f.full ? "sm:col-span-2" : ""}`}>
      <Label>{f.label}{f.required && " *"}</Label>
      <Input f={f} id={id} value={value} onChange={onChange} />
    </div>
  );
};
